<template>
  <div class=" d-flex flex-row align-center justify-space-between pa-2">
    <div class="mr-2" :class="titleClass">{{ title }}</div>
    <div v-if="isNaN(value)" :class="valueClass">
      {{ value }}
    </div>
    <div v-else :class="valueClass">{{ sign }} {{ value | currency }}</div>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "LedgerRow",
  props: {
    title: {
      type: String,
      default: ""
    },
    value: [String, Number],
    sign: {
      type: String,
      default: ""
    },
    valueClass: {
      type: String,
      default: ""
    },
    titleClass: {
      type: String,
      default: ""
    }
  },
  data: function() {
    return {};
  },
  methods: {},
  computed: {}
};
</script>

<style scoped></style>
